export default __webpack_public_path__ + "static/c90-f6138b9fa9b382a10ece0e541b73c7ba.png";